//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        surprise: {
            type: Object
        }
    },

    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    }
};
